export default __webpack_public_path__ + "static/media/icon-chart.763765fe.svg";